import { LOCALES } from 'i18n/locales';

export const supplementaryDataErrorIntl = {
    [LOCALES.ENGLISH]: {
        'supplementalError.alert': 'Supplementary data is not available at this time. Please redraw the area or contact us to <serviceDesk>get help</serviceDesk>.',
        'supplementary.error.notification.label': 'Supplementary data error'
    },
    [LOCALES.WELSH]: {
        'supplementalError.alert': 'Nid yw\'r data ychwanegol ar gael ar hyn o bryd. Ail-luniwch yr ardal neu cysylltwch â ni yn <serviceDesk>get help</serviceDesk>.',
        'supplementary.error.notification.label': 'Gwall data atodol'
    }
};
